export enum FormType {
  RATE = 'RATE',
  FEE = 'FEE',
  CRYPTO = 'CRYPTO',
}
